var _mask, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCooperation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_14858",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.175781 14.0591L24.0008 27.0991L47.8258 14.0591"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.175781 14.0591L24.0008 27.0991L47.8258 14.0591",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 27.0991L23.5207 27.9763L24.0008 28.2391L24.4809 27.9763L24.0008 27.0991ZM-0.304334 14.9363L23.5207 27.9763L24.4809 26.2219L0.655897 13.1819L-0.304334 14.9363ZM24.4809 27.9763L48.3059 14.9363L47.3457 13.1819L23.5207 26.2219L24.4809 27.9763Z",
    fill: "#3B4443",
    mask: "url(#path-1-inside-1_1_14858)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7199 13.5625L46.72 13.5626C46.9556 13.6915 47.1523 13.8813 47.2895 14.1122C47.4267 14.3431 47.4994 14.6065 47.5 14.8751V38.7828C47.4994 39.0514 47.4267 39.3149 47.2895 39.5457C47.1523 39.7766 46.9556 39.9664 46.72 40.0953L46.7199 40.0954L24.72 52.1403C24.72 52.1404 24.7199 52.1404 24.7199 52.1404C24.4991 52.2611 24.2516 52.3244 24 52.3244C23.7484 52.3244 23.5009 52.2611 23.2801 52.1404C23.2801 52.1404 23.28 52.1404 23.28 52.1403L1.28012 40.0954L1.28 40.0953C1.0444 39.9664 0.847723 39.7766 0.710516 39.5457C0.573401 39.315 0.500703 39.0517 0.5 38.7834V14.8746C0.500703 14.6062 0.573401 14.3429 0.710516 14.1122C0.847721 13.8813 1.04439 13.6915 1.28 13.5626L1.28012 13.5625L23.28 1.51759C23.28 1.51757 23.2801 1.51755 23.2801 1.51753C23.5008 1.39678 23.7484 1.3335 24 1.3335C24.2516 1.3335 24.4992 1.39678 24.7199 1.51753C24.7199 1.51755 24.72 1.51757 24.72 1.51759L46.7199 13.5625Z",
    stroke: "#3B4443"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.1014V52.8289",
    stroke: "#3B4443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperation);
export default __webpack_public_path__ + "static/media/cooperation.d76d6d88388a9e8aab561be83d88b4e5.svg";
export { ForwardRef as ReactComponent };